<button (click)="onItemClicked()" [attr.aria-expanded]="accordionOpen()" class="ap-list-item__container" data-testid="list-item-container">
    <ng-content></ng-content>
    <asn-icon [name]="getActionIcon()" class="ap-list-item__action" data-testid="chevron"></asn-icon>
</button>
@if (accordionOpen()) {
    <div data-testid="accordion-content">
        <ng-content select="[accordion-content]"></ng-content>
    </div>
}
